var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedLevel)?_c('TotemTag',{attrs:{"name":_vm.name},on:{"handleClick":function($event){return _vm.$emit('handleClick')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }